
import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

export default function usePDPModelSizeTagExperiment(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_MODEL_SIZE_TAG_VISIBILITY)
  const { pdpModelSizeTagEnabled = false } = useStatsigDynamicLocaleConfig()

  // Generic - no country knowledge, config from Statsig
  const showModelSizeTag = pdpModelSizeTagEnabled && experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW
  return showModelSizeTag
}
